export const dataAdjustmentResponse = order => {
  const missingDocuments = order && order.missingDocuments;
  const status = order.orderStatusId;
  // const offer = order.offerId;
  // const carrier = order.carrier;
  const orderVehicle = order.orderVehicle;
  return {
    info: {
      create: order.createdAt,
      update: order.updatedAt,
    },
    orderId: order.orderId,
    orderNumber: order.offerId && order.offerId.number,
    orderName:
      order.offerId &&
      order.offerId.requestId &&
      order.offerId.requestId.comment,
    documents: missingDocuments
      ? missingDocuments.map(doc => adjustDocs(doc))
      : [],
    orderVehicle: orderVehicle.length > 0 ? orderVehicle : 'Не указан',
    orderState: {
      status: status && status.orderStatus.split('.')[0], // "Архив. Снят по соглашению сторон." => "Архив"
      statusKey: status && status.orderStatusKey,
      statusId: status && status.orderStatusId,
      statusKeyGroup: status && status.orderStatusKey, // снизу проверка к какой группе относится
      color: '',
      description:
        order.orderStatusId &&
        order.orderStatusId.orderStatus
          .split('.')
          .slice(1)
          .join('.'), // "Архив. Снят по соглашению сторон." => "Снят по соглашению сторон"
    },
    /* 
    carrier: carrier ? carrier : 'Не указан',
    orderDrivers: order.orderDrivers ? order.orderDrivers : 'Не указан',
    observer: order.observer ? order.observer : 'Не указан',
    creator: order.creator ? order.creator : 'Не указан',
    хардкод
    */
    carrier: 'Не указан',
    orderDrivers: 'Не указан',
    observer: 'Не указан',
    creator: 'Не указан',
  };
};

const adjustDocs = document => {
  const status = document.documentStatusId;
  const type = document.documentTypeId;
  return {
    id: document.documentId,
    info: {
      type: type && type.documentTypeName,
      typeKey: type && type.documentTypeKey,
      typeId: type && type.documentTypeId,
    },
    status: {
      status: status && status.documentStatusName,
      statusId: status && status.documentStatusId,
      statusKey: status && status.documentStatusKey,
      fillType: document.fillTypeId,
      statusKeyGroup: status && status.documentStatusKey,
    },
    dateApplication: document.updatedAt
      ? document.updatedAt
      : document.createdAt,
    actions: ['edit', 'print', 'download'],
  };
};
